import { render, staticRenderFns } from "./VendorInvoiceDesign.vue?vue&type=template&id=3d445f2f&scoped=true&"
import script from "./VendorInvoiceDesign.vue?vue&type=script&lang=js&"
export * from "./VendorInvoiceDesign.vue?vue&type=script&lang=js&"
import style0 from "./VendorInvoiceDesign.vue?vue&type=style&index=0&id=3d445f2f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d445f2f",
  null
  
)

export default component.exports